var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{attrs:{"filterable":"","clearable":"","value":_vm.data,"placeholder":_vm.$t('请选择'),"disabled":_vm.disabled},on:{"change":_vm.handleChange}},_vm._l((_vm.list),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.name,"value":item.value}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-e862e25a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/PropsSelect/OperatorSelectByName.vue
// module id = null
// module chunks = 